import { Skeleton } from "components/common/skeleton";
import { SidebarLoadingStateProps } from "./SidebarLoadingState.types";

const NAV_PLACEHOLDER_ROWS = 6;

export const SidebarLoadingState = ({
  ariaLabel = "Loading navigation",
}: SidebarLoadingStateProps) => (
  <div
    role="status"
    aria-busy="true"
    aria-label={ariaLabel}
    className="flex w-full min-w-0 flex-col gap-2"
  >
    <Skeleton aria-hidden className="h-3 w-28 max-w-full shrink-0 self-start rounded" />
    {Array.from({ length: NAV_PLACEHOLDER_ROWS }, (_, index) => (
      <Skeleton key={index} aria-hidden className="h-8 w-full min-w-0 shrink-0 rounded-md" />
    ))}
  </div>
);
